import { AiButton } from '@/components/ai-chat';
import { ConfirmDialog } from '@/components/Dialogs/ConfirmDialog';
import { useLearningsBackfill } from '@/state/learnings/useLearningsBackfill';

type LearningsPastTestsProps = { websiteId: number };

const tests = (count: number) => (count === 1 ? '1 past test' : `${count.toLocaleString()} past tests`);

/**
 * Under the Learnings switch, once learnings are on and saved: the website's tests from before
 * that, which are written only when someone confirms the cost. Shown to the roles that can turn
 * learnings on; nothing at all when there are no such tests.
 */
export const LearningsPastTests = ({ websiteId }: LearningsPastTestsProps) => {
  const backfill = useLearningsBackfill({ websiteId, enabled: true });
  if (backfill.past === 0) return null;

  return (
    <div className="border-line flex flex-col gap-2 rounded-lg border p-3">
      <p className="supporting m-0">
        {tests(backfill.past)} from before learnings were turned on have no learning yet. Writing them uses about{' '}
        {backfill.estimate.toLocaleString()} AI credits.
      </p>
      {/* Spends AI credits, so it wears the AI button, as every AI action does. */}
      <AiButton onClick={backfill.askToConfirm} className="self-start">
        Write learnings for {tests(backfill.past)}
      </AiButton>

      <ConfirmDialog
        open={backfill.confirming}
        title={`Write learnings for ${tests(backfill.past)}?`}
        description={`This uses about ${backfill.estimate.toLocaleString()} of your account's AI credits, roughly ${backfill.creditsPerCard} per test. They are written in the background, a few at a time, and writing pauses if your credits run out.`}
        confirmLabel="Write learnings"
        onConfirm={backfill.confirm}
        onCancel={backfill.cancel}
      />
    </div>
  );
};
